export const baseUrl = 'https://apiqa.pbfintechaa.com/api/v2';
export const logoBaseUrl = ''; // logo base url
